import { ApiService } from 'src/app/services/api.service';
import { Injectable } from '@angular/core';
import { User, UserManager, UserManagerSettings, } from 'oidc-client';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
const apiYamahaBaseUrl = environment.apiAssetBase;
const apiAssetBaseUrl = environment.apiAssetBase;
@Injectable()
export class AuthService {

  private manager: UserManager = new UserManager(environment.authenSettings);
  private user: any = null;
  private account: any = null;
  constructor(
    private http: HttpClient,
    private router: Router
  ) {
  }

  // getUserMenus () {
  //   const options = {
  //     headers: new HttpHeaders({
  //       Authorization: `Bearer ${this.user.access_token}`,
  //       'Content-Type': 'application/json',
  //     })
  //   };
  //   this.http.get(`${apiAssetBaseUrl}/api/v1/Menu/GetUserMenus`, options)
  //   .subscribe((response: any) => {
  //     localStorage.setItem('assetUserPermission', JSON.stringify(response.data.permissions))
  //   });
  // }

  // async getAccountInfo (user) {
  //   const options = {
  //     headers: new HttpHeaders({
  //       Authorization: `Bearer ${user.access_token}`,
  //       'Content-Type': 'application/json',
  //     })
  //   };
  //   const data = {
  //     id: '',
  //     userId: user.profile.sub,
  //     name: user.profile.name,
  //     phone: '',
  //     email: '',
  //     loginName: '',
  //     avatar: ''
  //   }
  //   await this.http.post(`${apiAssetBaseUrl}/api/v1/user/GetUserInfo`, data, options)
  //   .subscribe((response: any) => {
  //     localStorage.setItem('assetUserPermission', JSON.stringify(response.data.permissions))
  //   });
  // }

  isLoggedIn(): Promise<boolean> {
    // localStorage.removeItem('menuItems');
    if (this.user != null) {
      return new Promise((resolve, reject) => resolve(!this.user.expired));
    }

    return this.manager.getUser().then(user => {
      this.user = user;
      return this.user != null && !user.expired;
      // return this.account != null ;
    });
  }

  getClaims(): any {
    return this.user.profile;
  }

  getPermissions(): any {
    return this.account;
  }

  getAuthorizationHeaderValue(): string {
    return `Bearer ${this.user.access_token}`;
  }

  getAccessTokenValue(): string {
    return this.user.access_token;
  }

  getUserName(): string {
    return this.user.profile.preferred_username;
  }

  isExpired(): boolean {
    return this.user.expired
  }

  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }

  signout(): Promise<void> {
    localStorage.removeItem('menuItems');
    localStorage.removeItem('tokenFb');
    localStorage.removeItem('account');
    return this.manager.signoutRedirect();
  }

  completeAuthentication(): Promise<void> {
    localStorage.setItem('projectCd', '01');
    return this.manager.signinRedirectCallback()
      .then(user => {
        this.user = user;
      //  console.log('user:', user);
        if (!user) {
          this.router.navigateByUrl('/');
        }
      })
      .then(_ => {
        // this.getEmpDetail()
      })
      .catch(error => {
        this.router.navigateByUrl('/');
        console.error('Complete authentication:', error);
      });
  }

  getUserImage(): string {
    return localStorage.getItem('avatarUrl') || '';
  }

   getEmpDetail() {
    const headers = new HttpHeaders({ Authorization: this.getAuthorizationHeaderValue() });
    // console.log(options)
    return this.http.get(environment.apiBase + '/api/v2/employee/GetEmployee?employeeId=', { headers }).toPromise()
      .then((emp: any) => {
        if (emp && emp.data) {
         // console.log(emp.data)
          localStorage.setItem('avatarUrl', emp.data.avatarUrl);
          localStorage.setItem('employeeId', emp.data.employeeId);
        }
      });
  }
  

  getAccount() {
    if(this.user) {
     const options = {
       headers: new HttpHeaders({
         Authorization: `${this.user.token_type} ${this.user.access_token}`
       })
     };

     this.getAccountLogin(options).subscribe(result => {
       if (result) {
         this.account = result;
         localStorage.setItem('account', JSON.stringify(this.account));
       }
     })
    }
 }

  getAccountLogin(options): Observable<any> {
    return this.http.post(`${apiYamahaBaseUrl}/api/v1/account/Login`, {},options);
  }

  getWorkingProject() {
    return localStorage.getItem('projectCd');
  }
}

export function getClientSettings(): UserManagerSettings {
  return {
    authority: 'https://api.sunshinegroup.vn:5000',
    client_id: 'web_s_service_dev',
    redirect_uri: 'http://localhost:4200/auth-callback',
    post_logout_redirect_uri: 'http://localhost:4200',
    response_type: 'id_token token',
    scope: 'openid profile api_sre',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    silent_redirect_uri: 'http://localhost:4200/silent-refresh.html'
  };
}
